import { UpdateType } from "@/types/programs";
import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import isYesterday from "dayjs/plugin/isYesterday";
import { useTranslation } from "react-i18next";
import preParsePostFormat from "dayjs/plugin/preParsePostFormat";
import { UpdateCard } from "./update-card";
import { CarouselComponent } from "@/pages/home/sections/CarouselComponent";

dayjs.extend(preParsePostFormat);
dayjs.extend(isYesterday);
dayjs.extend(isToday);

dayjs.locale("ar");
interface UpdateCardProps {
  bgColor: string;
  updates: UpdateType[];
}

const UpdatesSection = ({ bgColor, updates }: UpdateCardProps) => {
  const { t } = useTranslation();

  return (
    <section className="my-5 w-full pb-4 md:my-8 md:pb-0" id="updates">
      <h2 className="mx-[16px] mb-8 text-2xl font-bold md:mx-[24px] md:text-4xl">
        {t("header.updates")}
      </h2>
      <ul className="scrollbar-hide flex gap-4 overflow-x-auto md:gap-[24px]">
        {!updates?.length && (
          <li className={`col-span-4 mx-[16px] w-full space-y-16 font-normal md:mx-[24px]`}>
            <p className="text-2xl leading-tight sm:text-2xl">{t("update.no_updates")}</p>
          </li>
        )}
      </ul>
      <CarouselComponent imagesLg={3} imagesMd={1} isProgramDetail={true}>
        {updates.map((update) => (
          <div
            key={update.id}
            className={`
              m-0 [&>div]:h-full`}
          >
            <UpdateCard update={update} bgColor={bgColor} />
          </div>
        ))}
      </CarouselComponent>
    </section>
  );
};

export default UpdatesSection;
